import { ArrowRight } from 'lucide-react';

import { Button } from '../../../components/ui';
import { useDieuHuong } from '../../../hooks/useDuongDan';
import { useT } from '../../../i18n';
import { TabMucSuDung } from '../../token-ai/components/TabMucSuDung';
import { TheTomTatToken } from '../../token-ai/components/TheTomTatToken';
import { useHanMucTokenAi } from '../../tenant/hooks/useHanMucTokenAi';

/**
 * Thẻ Token AI của báo cáo: chỉ phần **đọc** — còn lại trên tổng, biểu đồ theo ngày và bốn bảng xếp hạng. Đặt hạn mức và
 * nạp token là việc ghi, ở lại màn `/token-ai`; thẻ này chỉ đặt một lối sang đó để màn báo cáo không dài thêm.
 */
export function TabTokenAi({ tenantId }: { tenantId: string }) {
  const { t } = useT();
  const navigate = useDieuHuong();
  const q = useHanMucTokenAi(tenantId);

  return (
    <div className="space-y-4">
      <TheTomTatToken q={q} />
      <div className="flex justify-end">
        <Button variant="ghost" size="md" onClick={() => navigate('/token-ai')}>
          {t('baoCao.quanLyToken')}
          <ArrowRight size={14} aria-hidden />
        </Button>
      </div>
      <TabMucSuDung tenantId={tenantId} />
    </div>
  );
}
